import { render } from "./NewsElement.vue?vue&type=template&id=40e7acd7&scoped=true"
import script from "./NewsElement.vue?vue&type=script&lang=js"
export * from "./NewsElement.vue?vue&type=script&lang=js"

import "./NewsElement.vue?vue&type=style&index=0&id=40e7acd7&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40e7acd7"]])

export default __exports__